<template>
  <Teleport
    to="#teleport-target-modal"
    tag="div"
  >
    <div

      class="com_modal com_modal--bottom-drawer"
    >
      <div

        ref="alertContainer"
        tabindex="0"
        class="com_modal__inner-wrap"
        @keyup.esc="onClickCancel"
      >
        <div class="com_modal__flex-container">
          <transition
            appear
            name="modal-slide"
            @after-leave="afterCloseAnimation"
          >
            <div
              v-if="isOpen"
              :class="{
                'com_modal__window--animated-attention': isWobblingAnimationActive,
              }"
              class="com_modal__window uti_padding-bottom-0"
            >
              <div class="com_modal__content">
                <div class="com_modal__window-body">
                  <h4 class="uti_margin-bottom-0">
                    {{ $t('layout.should_the_form_entries_be_discarded') }}
                  </h4>
                </div>

                <PfButtonBar
                  class="com_modal__window-footer com_button-bar--inner-padding"
                  size="lg"
                >
                  <PfButtonBarButton
                    class="obj_button--red"
                    data-testid="unsaved-changes-confirm-btn"
                    @click="onClickConfirm"
                  >
                    {{ $t('layout.discard_changes') }}
                  </PfButtonBarButton>

                  <PfButtonBarLink
                    data-testid="unsaved-changes-cancel-btn"
                    @click="onClickCancel"
                  >
                    {{ $t('layout.keep_editing') }}
                  </PfButtonBarLink>
                </PfButtonBar>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <transition
        appear
        name="darkener-fade"
      >
        <PfDarkener
          v-if="isOpen"
          @click="onClickDarkener"
        />
      </transition>
    </div>
  </Teleport>
</template>

<script>
import PfButtonBar from '@/components/PfButtonBar.vue'
import PfButtonBarButton from '@/components/PfButtonBarButton.vue'
import PfButtonBarLink from '@/components/PfButtonBarLink.vue'
import PfDarkener from '@/components/PfDarkener.vue'

export default {
  name: 'AlertModalConfirm',

  components: {
    PfButtonBar,
    PfButtonBarLink,
    PfButtonBarButton,
    PfDarkener,
  },

  emits: [
    'on:discard',
    'on:keep',
    'after:close-animation',
  ],

  expose: [ 'close' ],

  data () {
    return {
      isWobblingAnimationActive: false,
      isOpen: true,
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (this.$refs.alertContainer) {
        this.$refs.alertContainer.focus()
      }
    })
  },

  methods: {
    onClickConfirm () {
      this.$emit('on:discard')
      this.close()
    },

    onClickCancel () {
      this.$emit('on:keep')
      this.close()
    },

    onClickDarkener () {
      // Don't run animation twice
      if (this.isWobblingAnimationActive) {
        return
      }

      this.isWobblingAnimationActive = true

      // We assume that the animation is not running longer than 1000ms
      setTimeout(() => {
        this.isWobblingAnimationActive = false
      }, 1000)

      // this.onClickCancel()
    },

    close () {
      this.isOpen = false
    },

    afterCloseAnimation () {
      this.$emit('after:close-animation')
    },
  },
}
</script>
